// @ vendors
const get = require('lodash/object/get');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');

// @ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { calculateContract } = require('utilities/ibanHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const signaturePatternActions = require('actions/signaturePattern');
const gdprConsentsActions = require('actions/gdprConsents');
const {
    ACCOUNT_INTERVENTION_INDISTINCT_CODE,
    ACCOUNT_INTERVENTION_OWNER_CODE,
    HIRE_E_ACCOUNT_MANAGER,
    SECOND_STEP
} = require('constants/index');
const {
    WELCOME_ACCOUNT_PRODUCT_ALIAS,
    WELCOME_PAYROLL_ACCOUNT_PRODUCT_ALIAS,
    WELCOME_ACCOUNT_ALIAS
} = require('constants/hiringProductInformation');

// @actions
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');
import { registerDocuments } from 'actions/registerDocuments';

const hireWelcomeAccountFailure = (error) => ({
    type: actionTypes.WELCOME_ACCOUNT_HIRE_FAILURE,
    payload: error
});

const hireWelcomeAccountInProgress = () => ({
    type: actionTypes.WELCOME_ACCOUNT_HIRE_IN_PROGRESS
})

const hireWelcomeAccountSuccess = (response) => {
    const contractNumber = get(response, 'cuentaSeleccionadaCCC.numerodecontrato');
    const product = get(response, 'cuentaSeleccionadaCCC.producto');

    response.accountNumber = calculateContract(product+contractNumber);

    return {
        type: actionTypes.WELCOME_ACCOUNT_HIRE_SUCCESS,
        payload: {
            response
        }
    }
}

const hireWelcomeAccount = (dispatch, getState, data, termsAndsCondsHiringData, isPayroll, upgradedVersion = false) => {
    const { alias, productInformation, operationProcessId } = termsAndsCondsHiringData;
    const url = isPayroll ? apiURLBuilder.getURL('hireWelcomePayrollAccount') : apiURLBuilder.getURL('hireWelcomeAccount');
    const requestData = {
        ...(upgradedVersion && { header: { version: 2 } }),
        query: data
    };

    return APIPost(dispatch, url, requestData)
        .then(response => {
            if (operationProcessId) {
                const preContractualOperationProcessId = getState().preContractualPolling.get('operationProcessId');
                const contractNumber = response.cuentaSeleccionada.numerodecontrato;
                const product = response.cuentaSeleccionada.producto;
                const registerDocumentsData =  {
                    query: {
                        processes: [
                            {
                                processRelation: "PRECONTRACTUAL",
                                operationProcessId: preContractualOperationProcessId
                            },
                            {
                                processRelation: "CONTRACTUAL",
                                operationProcessId: operationProcessId
                            }
                        ],
                        productAlias: WELCOME_ACCOUNT_ALIAS,
                        contract: contractNumber,
                        product: product,
                    }
                }
                dispatch(registerDocuments(registerDocumentsData));
            }
            dispatch(hireWelcomeAccountSuccess(response));
            dispatch(setTermsAndCondsInfo(alias, productInformation, operationProcessId));
        })
        .catch(response => dispatch(hireWelcomeAccountFailure(response.error.description)))
};

const finishWelcomeAccount = (welcomeAccountParams, operationProcessId = null, upgradedVersion = false) => (dispatch, getState) => {
    dispatch(hireWelcomeAccountInProgress());
    const callback = (dispatch, getState, dataToken) => {
        const { hireWelcomeAccount: immhireWelcomeAccount } = getState();
        const accountId = immhireWelcomeAccount.getIn(['steps', SECOND_STEP, 'selectedAccount']);
        const immAccount = getState().accounts.getIn(['byId', accountId]);
        const immInterveners = immhireWelcomeAccount.getIn(['steps', SECOND_STEP, 'interveners']);
        const firstTitularIndex = immInterveners.findIndex(immIntervener =>
            immIntervener.get('typeNumber') === ACCOUNT_INTERVENTION_OWNER_CODE
        );
        const firstTitular = immInterveners.get(firstTitularIndex);
        const groupedInterveners = immInterveners.delete(firstTitularIndex)
            .groupBy(intervener => intervener.get('typeNumber'));
        const parsedInterveners = [];

        groupedInterveners.forEach((immIntervenerList, intervenerType) => {
            immIntervenerList.forEach((immIntervener, index) => {
                parsedInterveners.push({
                    formaIntervencion: intervenerType === ACCOUNT_INTERVENTION_OWNER_CODE || immIntervenerList.size > 1  ? ACCOUNT_INTERVENTION_INDISTINCT_CODE: ACCOUNT_INTERVENTION_OWNER_CODE,
                    numOrdenIntervencion: index + 1,
                    numeroPersona: parseInt(immIntervener.getIn(['identification','code']),10),
                    tipoIntervencion: intervenerType,
                    tipoPersona: immIntervener.getIn(['identification', 'type'])
                });
            });
        });

        const contractData = {
            campana: '0001',
            codEstandarReferencia: welcomeAccountParams.standard,
            codMoneda: immAccount.getIn(['balance', 'currency']),
            cuentaSeleccionada: {
                numerodecontrato: immAccount.get('contractNumber'),
                producto: immAccount.get('product')
            },
            cuentaSeleccionadaCCC: {
                digitodecontrol: immAccount.getIn(['ibanComplex', 'digitodecontrol']),
                numerodecuenta: immAccount.get('product') + immAccount.get('contractNumber')
            },
            dataToken,
            gestor: HIRE_E_ACCOUNT_MANAGER,
            idProducto: welcomeAccountParams.type,
            idSubproducto: welcomeAccountParams.subType,
            idioma: 'E',
            indTalonario: 'N',
            lista: {
                dato: parsedInterveners
            },
            primerTitular: {
                codigodepersona: parseInt(firstTitular.getIn(['identification', 'code']), 10),
                tipodepersona: firstTitular.getIn(['identification', 'type'])
            },
            tipoCuenta: 'C'
        };

        let alias;
        let productInformation;

        if (welcomeAccountParams.isPayroll) {
            alias = WELCOME_PAYROLL_ACCOUNT_PRODUCT_ALIAS;
            productInformation = [
                {
                    standard: welcomeAccountParams.standard,
                    subType: welcomeAccountParams.subType,
                    type: welcomeAccountParams.type,
                }
            ]
        } else {
            alias = WELCOME_ACCOUNT_PRODUCT_ALIAS;
            productInformation = [
                {
                    passportProductId: alias,
                }
            ];
        }

        const termsAndsCondsHiringData = {
            alias,
            productInformation,
            ...(operationProcessId && { operationProcessId })
        };

        dispatch(gdprConsentsActions.updateConsents(dataToken))
            .then(() => hireWelcomeAccount(dispatch, getState, contractData, termsAndsCondsHiringData, welcomeAccountParams.isPayroll, upgradedVersion))
            .catch(response => {
                if(!!response.error) {
                    hireWelcomeAccount(dispatch, getState, contractData, termsAndsCondsHiringData, welcomeAccountParams.isPayroll, upgradedVersion);
                } else {
                    throw response;
                }
            });
    };

    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
}

const onCheckboxChange = () => ({
    type: actionTypes.WELCOME_ACCOUNT_CHECKBOX_CHANGE
})

const setVisibleStep = step => ({
    type: actionTypes.WELCOME_ACCOUNT_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const setWillCancel = willCancel => ({
    type: actionTypes.WELCOME_ACCOUNT_SET_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const setLegalTextRead = () => ({
    type: actionTypes.WELCOME_ACCOUNT_SET_LEGAL_TEXT_READ
});

const validateStep = step => ({
    type: actionTypes.WELCOME_ACCOUNT_VALIDATE_STEP,
    payload: {
        step
    }
});

const setSelectedAccountValue = value => ({
    type: actionTypes.WELCOME_ACCOUNT_SET_SELECTED_ACCOUNT,
    payload: {
        selectedAccount: value
    }
});

const setIntervenerType = (index, type, changeTypeByIntervenerCode) => ({
    type: actionTypes.WELCOME_ACCOUNT_SET_ACCOUNT_INTERVENER_TYPE,
    payload: {
        index,
        type,
        changeTypeByIntervenerCode
    }
});

const addIntervener = () => ({
    type: actionTypes.WELCOME_ACCOUNT_ADD_INTERVENER
});

const removeIntervener = (index, originalInterveners) => ({
        type: actionTypes.WELCOME_ACCOUNT_REMOVE_INTERVENER,
        payload: {
            index,
            originalInterveners
        }
});

const restoreDefaultInterveners = (originalInterveners) => ({
    type: actionTypes.WELCOME_ACCOUNT_RESTORE_DEFAULT_INTERVENERS,
    payload: {
        originalInterveners
    }
});

const requestIntervenersInProgress = () => ({
    type: actionTypes.WELCOME_ACCOUNT_UPDATE_INTERVENERS_IN_PROGRESS
});

const requestIntervenersSuccess = inteveners => ({
    type: actionTypes.WELCOME_ACCOUNT_UPDATE_INTERVENERS,
    payload: {
        inteveners
    }
});

const requestIntervenersFailure = error => ({
    type: actionTypes.WELCOME_ACCOUNT_UPDATE_INTERVENERS_FAILURE,
    payload: {
        error
    }
});

const requestInterveners = (immAccount) => dispatch => {
    const requestData = {
        query: {
            producto: immAccount.get('product'),
            numeroContrato: immAccount.get('contractNumber')
        }
    };

    dispatch(requestIntervenersInProgress());

    return APIGet({
        dispatch,
        endpoint: 'hiringInterveners',
        params: requestData
    })
    .then(response => {
        dispatch(requestIntervenersSuccess(response.dato));
    })
    .catch(response => {
        if (response.error) {
            dispatch(requestIntervenersFailure(response.error.description));
        } else {
            throw response;
        }
    });
};

const resetHireWelcome = () => ({
    type: actionTypes.WELCOME_ACCOUNT_RESET
})

const resetPrecontractualDocument = () => ({
    type: actionTypes.WELCOME_ACCOUNT_RESET_PRECONTRACTUAL_DOCUMENT
});

const resetPolling = () => ({
    type: actionTypes.WELCOME_ACCOUNT_RESET_POLLING
});


module.exports = {
    addIntervener,
    finishWelcomeAccount,
    onCheckboxChange,
    requestInterveners,
    removeIntervener,
    resetHireWelcome,
    resetPolling,
    resetPrecontractualDocument,
    restoreDefaultInterveners,
    setIntervenerType,
    setLegalTextRead,
    setSelectedAccountValue,
    setVisibleStep,
    setWillCancel,
    validateStep
}
